import { FC } from 'react';
import IrrelevantAppsContainer from '../../../irrelevant-apps/containers/IrrelevantAppsContainer';

const IrrelevantAppsPage: FC<React.PropsWithChildren<unknown>> = () => {
  return <IrrelevantAppsContainer />;
};

export default IrrelevantAppsPage;
